module.exports = __webpack_public_path__ + "img/v1-dashboard-mobile.861e30b6.png";